// elements/x-components.ts
import { html, svg } from "lit";
import { DesignSystem } from "./theming/design";
var templateResultCache = /* @__PURE__ */ new WeakMap();
var xComponents = (templateResult) => {
  const templateResultCacheHit = templateResultCache.get(templateResult.strings);
  if (templateResultCacheHit) {
    const values2 = templateResult.values.map(
      (value) => value?._$litType$ === 1 ? xComponents(value) : value
    );
    return { ...templateResultCacheHit, values: values2 };
  }
  const designSystemPrefix = DesignSystem.prefix;
  const strings = templateResult.strings;
  const replacedStrings = strings.map((str) => str.replace(/<([\/]{0,1})x-/g, `<$1${designSystemPrefix}-`));
  replacedStrings.raw = strings.raw.map((str) => str.replace(/<([\/]{0,1})x-/g, `<$1${designSystemPrefix}-`));
  const values = templateResult.values.map(
    (value) => value?._$litType$ === 1 ? xComponents(value) : value
  );
  const finalTemplateResult = templateResult._$litType$ === 2 ? svg(replacedStrings, ...values) : html(replacedStrings, ...values);
  templateResultCache.set(templateResult.strings, finalTemplateResult);
  return finalTemplateResult;
};
export {
  xComponents
};
